import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './card.module.scss';

export const Card = memo(({ children }) => <div className={styles.container}>{children}</div>);

Card.propTypes = {
  children: PropTypes.node.isRequired,
};
